import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Statistic, Spin, message } from 'antd';
import { UserOutlined, BookOutlined, BankOutlined } from '@ant-design/icons';
import { fetchDashboardStats, type DashboardStats } from '@/services/dashboard/api.dashboard';

interface DashboardCardsProps {
  className?: string;
  currentUser?: any;
}

const DashboardCards: React.FC<DashboardCardsProps> = ({ className, currentUser }) => {
  const [stats, setStats] = useState<DashboardStats>({
    total_courses: 0,
    total_employees: 0,
    total_companies: 0,
  });
  const [loading, setLoading] = useState<boolean>(true);

  const loadDashboardStats = async () => {
    try {
      setLoading(true);
      let id = ""
      if (currentUser?.role === 'company') {
        id = currentUser?.id
      }
      const data = await fetchDashboardStats(id,currentUser?.role);
      setStats(data);
    } catch (error: any) {
      console.error('Error loading dashboard stats:', error);
      message.error('Failed to load dashboard statistics');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDashboardStats();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className={className}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Total Courses"
              value={stats.total_courses}
              prefix={<BookOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Total Employees"
              value={stats.total_employees}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        {currentUser?.role === 'admin' &&
          <Col xs={24} sm={12} lg={8}>
            <Card>
              <Statistic
                title="Total Companies"
                value={stats.total_companies}
                prefix={<BankOutlined />}
                valueStyle={{ color: '#cf1322' }}
              />
            </Card>
          </Col>}
      </Row>
    </div>
  );
};

export default DashboardCards;
